import React, { useState } from "react";
import { IoIosArrowBack } from "react-icons/io";
import { FaArrowLeftLong } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
import { axiosInstance } from "../../axiosInstance";
import { useFormik } from "formik";
import { object, string } from "yup";
import { toast } from "react-toastify";

const validationSchema = object().shape({
  vehicle_type: string().required("Vehicle Type is required"),
  ryder_charges: string().required("Ryder Charges is required"),
  gomak_commision: string().required("Gomak Commision is required"),
  ryder_gst: string().required("Ryder Gst is required"),
  gomak_gst: string().required("Gomak Gst is required"),
});

export const AddPricing = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const formik = useFormik({
    initialValues: {
      vehicle_type: "",
      ryder_charges: "",
      gomak_commision: "",
      ryder_gst: "",
      gomak_gst: "",
    },
    validationSchema,
    onSubmit: async (values) => {
      setLoading(true);
      try {
        const payload = {
          vehicle_type: values.vehicle_type.trim(),
          ryder_charges: values.ryder_charges.trim(),
          gomak_commision: values.gomak_commision.trim(),
          ryder_gst: values.ryder_gst.trim(),
          gomak_gst: values.gomak_gst.trim(),
        };
        const response = await axiosInstance.post(
          "/admin/pricemaster/",
          payload
        );

        if (response.data.status === "success") {
          toast.success("Pricing added successfully!");
          setTimeout(() => navigate("/pricing"), 1500);
        } else {
          alert(response.data.message || "Failed to add Pricing.");
          toast.error("Something went wrong. Please try again.");
        }
      } catch (err) {
        console.error("❌ Error posting Pricing:", err);
        alert("Something went wrong. Please try again.");
        toast.error("Something went wrong. Please try again.");
      } finally {
        setLoading(false);
      }
    },
  });

  const handleCancel = () => {
    formik.resetForm();
  };

  return (
    <div className="addAdmin-container">
      <div className="addAdmin-subcontainer">
        <FaArrowLeftLong
          style={{ cursor: "pointer" }}
          onClick={() => navigate("/pricing")}
        />
        <div className="add-title">Add Pricing</div>
      </div>
      <form onSubmit={formik.handleSubmit}>
        <div className="addAdmin-content">
          <div className="addAdmin-contentLeft">
            <div className="addAdmin-field">
              <label>
                <span className="text-danger">*</span> Vehicle Type
              </label>
              <div>
                <input
                  type="text"
                  name="vehicle_type"
                  placeholder="Enter Your Vehicle Type"
                  value={formik.values.vehicle_type}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.vehicle_type && formik.errors.vehicle_type && (
                  <div className="text-danger">
                    {formik.errors.vehicle_type}
                  </div>
                )}
              </div>
            </div>
            <div className="addAdmin-field">
              <label>
                <span className="text-danger">*</span> Ryder Charges
              </label>
              <div>
                <input
                  type="text"
                  name="ryder_charges"
                  placeholder="Enter Your Ryder Charges"
                  value={formik.values.ryder_charges}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.ryder_charges &&
                  formik.errors.ryder_charges && (
                    <div className="text-danger">
                      {formik.errors.ryder_charges}
                    </div>
                  )}
              </div>
            </div>
            <div className="addAdmin-field">
              <label>
                <span className="text-danger">*</span> Gomak GST
              </label>
              <div>
                <input
                  type="text"
                  name="gomak_gst"
                  placeholder="Enter Your gomak GST"
                  value={formik.values.gomak_gst}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.gomak_gst && formik.errors.gomak_gst && (
                  <div className="text-danger">{formik.errors.gomak_gst}</div>
                )}
              </div>
            </div>
          </div>
          <div className="addAdmin-contentRight">
            <div className="addAdmin-field">
              <label>
                <span className="text-danger">*</span> Gomak Commision
              </label>
              <div>
                <input
                  type="text"
                  name="gomak_commision"
                  placeholder="Enter Your Gomak Commision"
                  value={formik.values.gomak_commision}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.gomak_commision &&
                  formik.errors.gomak_commision && (
                    <div className="text-danger">
                      {formik.errors.gomak_commision}
                    </div>
                  )}
              </div>
            </div>
            <div className="addAdmin-field">
              <label>
                <span className="text-danger">*</span> Ryder GST
              </label>
              <div>
                <input
                  type="text"
                  name="ryder_gst"
                  placeholder="Enter Your Ryder GST"
                  value={formik.values.ryder_gst}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.ryder_gst && formik.errors.ryder_gst && (
                  <div className="text-danger">{formik.errors.ryder_gst}</div>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="addbtnContainer">
          <div>
            <button
              type="button"
              className="admin-btnCancel"
              onClick={handleCancel}
              disabled={loading}
            >
              Cancel
            </button>
          </div>
          <div>
            <button className="add-btnSave" disabled={loading}>
              {loading ? "Saving..." : "Save"}
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};
